import React, { useEffect, useState, useRef } from "react";
import API from "../../../services/axiosInstance";
import { useParams, Link } from "react-router-dom";
import { Button, Alert } from "react-bootstrap";
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
const Amp = () => {
    const {id, guid} = useParams();
    const [ampTags, setAmpList] = useState([]);
    const [copiedIndex, setCopiedIndex] = useState(null);
    // For Loading 
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

    const pubNameRef = useRef("");
    const ampTagList = async () => {
       startLoading();
        try {
            const res = await API.get(`/publisher/adplacement/amp/tags/${id}`);
            if(res?.data?.status === "Success") {
                pubNameRef.current = res?.data?.name;
                setAmpList(res?.data?.data)
                console.log(res?.data?.data);        
            }
        } catch (error) {
            console.error("something went wrong");
        } finally {
            stopLoading();
        }
    }
    console.log(pubNameRef.current);
    
    const handleCopy = (text, index) => {
        navigator.clipboard.writeText(text);
        setCopiedIndex(index);
        setTimeout(() => setCopiedIndex(null), 1500);
    }

    useEffect(()=>{
        ampTagList();
    }, []);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
         <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                 <span>{pubNameRef.current}</span>
                <Link to={`/publisher/adplacement-list/${id}/${guid}`}><span>Manage Adplacement</span></Link>
                <span>AMP Tags</span>
        </div>
        {/* <div className=""> */}
            { 
              ampTags?.length > 0 ? 
                ampTags.map((items, index) =>{
                    const formatted = items.replace(/\t/g, "    ");
                    return (
                        <div key={index} style={{marginBottom:"20px",border:"1px solid #ddd",background:"#ffffff",boxShadow: "0 2px 6px rgba(0,0,0,0.05)"}}>
                            <div style={{padding:"10px 15px", borderBottom:"1px solid #eee", display:"flex", justifyContent:"space-between",alignItems:"center",background:"#fafafa",borderRadius:"8px 8px 0 0"}}>

                                <button onClick={()=> handleCopy(items, index)} style={{ padding: "5px 10px",fontSize: "12px",borderRadius: "4px",border: "1px solid #ccc",color:"#222222",background: copiedIndex === index ? "#d4edda" : "#f8f9fa",cursor: "pointer"}}>
                                    {copiedIndex === index ? "Copied!" : "Copy"}
                                </button>
                                
                            </div>
                            <pre style={{margin: 0,padding: "12px",fontSize: "13px",lineHeight: "1.5",overflowX: "auto",whiteSpace: "pre-wrap",background: "#f5f5f5",borderRadius: "0 0 8px 8px"}}>
                                <code>{formatted}</code>
                            </pre>
                        </div>
                    )
                })
                : 
                <Alert variant="success"> No Amp Tags </Alert>
            }
        {/* </div> */}
        </FormLoader>
  );

}


export default Amp;